import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// 1. Import your components
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import { API, UPLOADS } from "./../../config/api";

export default function Wishlist() {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  // 2. States for the popups
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [concepts, setConcepts] = useState([]);

  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);
  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();

      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log("Concept fetch error", error);
    }
  };
  const handleCardClick = (design) => {
    navigate(`/designe-details/${design.id}`, { state: design });
  };

  const cartIds = cart.filter((i) => i.type === "design").map((i) => i.id);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    const loadData = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      setUser(loginUser);

      if (loginUser) {
        const savedWishlist =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
        setWishlist(savedWishlist);

        const savedCart =
          JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
        setCart(savedCart);
      }
    };

    loadData();
    window.addEventListener("userLogin", loadData);
    window.addEventListener("userLogout", loadData);

    return () => {
      window.removeEventListener("userLogin", loadData);
      window.removeEventListener("userLogout", loadData);
    };
  }, []);

  const addToCart = (item, type) => {
    if (!user) {
      setShowLogin(true);
      return;
    }

    let existingCart =
      JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];

    const alreadyExists = existingCart.find(
      (i) => i.id === item.id && i.type === type,
    );

    if (alreadyExists) {
      // REMOVE from cart
      existingCart = existingCart.filter(
        (i) => !(i.id === item.id && i.type === type),
      );
    } else {
      // ADD to cart
      existingCart.push({
        ...item,
        type,
      });
    }

    localStorage.setItem(`cart_${user.id}`, JSON.stringify(existingCart));

    setCart(existingCart);

    // update navbar count
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const removeFromWishlist = (id, type) => {
    const updated = wishlist.filter(
      (item) => !(item.id === id && item.type === type),
    );
    setWishlist(updated);
    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(updated));

    // TRIGGER NAVBAR UPDATE
    window.dispatchEvent(new Event("cartUpdated"));
  };
  /* ================= FILTER BY TYPE ================= */
  const machines = wishlist.filter((i) => i.type === "machine");
  const designers = wishlist.filter((i) => i.type === "designer");
  const houses = wishlist.filter((i) => i.type === "house");
  const designs = wishlist.filter((i) => i.type === "design");

  /* ================= LOGIN CHECK RENDER ================= */
  if (!user) {
    return (
      <div className="container text-center mt-5 py-5 border rounded bg-light shadow-sm">
        <i className="bi bi-heart-break fs-1 text-muted"></i>
        <h4 className="mt-3 fw-bold">Please Login to View Your Wishlist</h4>
        <p className="text-muted">
          Save your favorite designs, machines, and workspaces to view them
          here.
        </p>

        {/* Trigger Pop-up */}
        <button
          className="btn btn-primary px-5 py-2 mt-2 fw-bold"
          onClick={() => setShowLogin(true)}
        >
          Login Now
        </button>

        {/* Pop-up components */}
        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
            setShowRegister(true);
          }}
        />
        <Register
          isOpen={showRegister}
          onClose={() => setShowRegister(false)}
          openLogin={() => {
            setShowRegister(false);
            setShowLogin(true);
          }}
        />
      </div>
    );
  }
  const allWishlistItems = [...machines, ...designers, ...houses, ...designs];
  return (
    <div className="container-fluid wishlist-page">
      <div className="row">
        {/* ================= LEFT ================= */}

        <div className="col-lg-10">
          <h2 className="section-title mb-4">
            My Wishlist ({wishlist.length})
          </h2>
          <div className="designs-grid1">
            {allWishlistItems.map((item) => {
              /* ================= MACHINE ================= */
              if (item.type === "machine") {
                const images = item.image ? item.image.split(",") : [];

                return (
                  <div className="design-card" key={item.id}>
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.MACHINE_IMAGE}${images[0]}`}
                        alt={item.machine_name}
                      />

                      <span className="heads-badge">
                        {item.NoOfHeads} Heads
                      </span>
                    </div>

                    <div className="machine-body">
                      <div className="machine-type">
                        <h4 className="machine-name">{item.machine_name}</h4>
                      </div>
                      {/* PRICE + CONTACT BUTTON ROW */}
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">
                            {Number(item.price).toLocaleString("en-IN")}
                          </span>
                        </div>

                        <button
                          className="contact-btn"
                          style={{
                            backgroundColor: "#00a699",
                            color: "white",
                            border: "none",
                            padding: "8px 14px",
                            borderRadius: "5px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => navigate(`/productdetails/${item.id}`)}
                        >
                          <i className="bi bi-telephone-fill me-1"></i> Contact
                        </button>
                      </div>

                      <div className="spec-row">
                        <div className="spec-item">
                          <span className="spec-label">Brand:</span>
                          <span className="spec-value">{item.brand}</span>
                        </div>
                        <div className="spec-item">
                          <span className="spec-label">Model:</span>
                          <span className="spec-value">{item.model}</span>
                        </div>
                      </div>

                      <div className="location-info">
                        <i className="bi bi-geo-alt-fill"></i>
                        {item.city}, {item.state}
                      </div>

                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={() => navigate(`/productdetails/${item.id}`)}
                        >
                          <i className="bi bi-info-circle me-2"></i>
                          More Details
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={() => removeFromWishlist(item.id, "machine")}
                        >
                          <i className="bi bi-heart-fill text-danger"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              /* ================= DESIGNER ================= */
              if (item.type === "designer") {
                return (
                  <div className="design-card" key={item.id}>
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                        className="designer-img"
                        alt={item.name}
                        style={{
                          height: "100%",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                      <span className="heads-badge">{item.experience} Exp</span>
                    </div>

                    <div className="machine-body">
                      <div className="machine-type">
                        <h4 className="machine-name">{item.name}</h4>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">{item.expected_salary}</span>
                          <span className="text-muted small"> </span>
                        </div>
                        <button
                          className="contact-btn"
                          onClick={() =>
                            navigate(`/designerdetails/${item.id}`)
                          }
                        >
                          <i className="bi bi-telephone-fill me-1"></i> Contact
                        </button>
                      </div>
                      <div className="spec-row mt-1">
                        <div className="spec-item">
                          <span className="spec-label">Skills:</span>
                          <span className="spec-value">{item.skills}</span>
                        </div>
                      </div>
                      <div className="location-info">
                        <i className="bi bi-geo-alt-fill"></i> {item.location}
                      </div>

                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={() =>
                            navigate(`/designerdetails/${item.id}`)
                          }
                        >
                          <i className="bi bi-person-badge-fill me-2"></i>
                          Hire Now
                        </button>
                        <button
                          className="footer-like-btn"
                          onClick={() =>
                            removeFromWishlist(item.id, "designer")
                          }
                        >
                          <i className="bi bi-heart-fill text-danger"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              /* ================= WORKSPACE ================= */
              if (item.type === "house") {
                const images = item.image ? item.image.split(",") : [];

                return (
                  <div className="design-card" key={item.id}>
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.WORKSPACE_IMAGE}${images[0]}`}
                        alt="workspace"
                      />
                      <span className="heads-badge">{item.floor} </span>
                    </div>

                    <div className="machine-body">
                      <div className="machine-type">
                        <h4 className="machine-name">{item.location}</h4>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">
                            {parseInt(item.rent_price).toLocaleString("en-IN")}
                          </span>
                          <span className="rent-unit"> </span>
                        </div>
                        <button
                          className="contact-btn"
                          onClick={() =>
                            navigate(`/houserentDetails/${item.id}`)
                          }
                        >
                          <i className="bi bi-telephone-fill me-1"></i> Contact
                        </button>
                      </div>

                      <div className="spec-row mt-1">
                        <div className="spec-item">
                          <span className="spec-label">Size:</span>
                          <span className="spec-value"> {item.size} </span>
                        </div>
                      </div>

                      <div className="location-info">
                        <i className="bi bi-geo-alt-fill"></i>
                        {item.city},{item.state}
                      </div>

                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={() =>
                            navigate(`/houserentDetails/${item.id}`)
                          }
                        >
                          <i className="bi bi-info-circle me-2"></i> View
                          Details
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={() => removeFromWishlist(item.id, "house")}
                        >
                          <i className="bi bi-heart-fill text-danger"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              /* ================= DESIGN ================= */
              if (item.type === "design") {
                return (
                  <div
                    className="design-card"
                    key={item.id}
                    onClick={() => handleCardClick(item)}
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${UPLOADS.DESIGN_IMAGE}${item.jpeg_file}`}
                        alt={item.design_code}
                      />
                    </div>

                    <div className="card-body">
                      <div className="design-specs">
                        <div className="spec-left">
                          <div>
                            <strong>Stitch:</strong> {item.stitch}
                          </div>
                          <div>
                            <strong>Color:</strong> {item.color}
                          </div>
                        </div>
                        <div className="spec-right text-end">
                          <div>
                            <strong>Area:</strong> {item.area}
                          </div>
                          <div>
                            <strong>Code:</strong> {item.design_code}
                          </div>
                          {/* <div><strong>Detail:</strong> {design.details}</div> */}
                        </div>
                      </div>
                      <div className="design-specs">
                        <div>
                          <strong>Concept:</strong>{" "}
                          {item.concepts_array
                            ?.map((id) => {
                              const concept = concepts.find((c) => c.id == id);
                              return concept ? concept.concept_name : null;
                            })
                            .filter(Boolean)
                            .join(", ")}
                        </div>
                      </div>

                      <h5 className="price-tag-row text-center mt-2">₹ 0</h5>

                      <div className="card-action-row">
                        <div className="action-btns">
                          <button
                            className={`select-btn ${cartIds.includes(item.id) ? "selected-btn" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              addToCart(item, "design");
                            }}
                          >
                            <i
                              className={`bi ${
                                cartIds.includes(item.id)
                                  ? "bi-cart-check-fill"
                                  : "bi-cart-fill"
                              } me-1`}
                            ></i>

                            {cartIds.includes(item.id)
                              ? "SELECTED"
                              : "SELECT DESIGN"}
                          </button>

                          <button
                            className="wish-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeFromWishlist(item.id, "design");
                            }}
                          >
                            <i className="bi bi-heart-fill text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>
          {/* ================= MACHINE SECTION ================= */}

          {/* {machines.length > 0 && (
            <>
              <h4 className="mb-3">Embroidery Machines</h4>

              <div className="designs-grid1">
                {machines.map((item) => {
                  const images = item.image ? item.image.split(",") : [];

                  return (
                    <div className="design-card" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.MACHINE_IMAGE}${images[0]}`}
                          alt={item.machine_name}
                        />

                        <span className="heads-badge">
                          {item.NoOfHeads} Heads
                        </span>
                      </div>

                      <div className="machine-body">
                        <div className="machine-type">
                          <h4 className="machine-name">{item.machine_name}</h4>
                        </div>
                        
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {Number(item.price).toLocaleString("en-IN")}
                            </span>
                          </div>

                          <button
                            className="contact-btn"
                            style={{
                              backgroundColor: "#00a699",
                              color: "white",
                              border: "none",
                              padding: "8px 14px",
                              borderRadius: "5px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() =>
                              navigate(`/productdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>

                        <div className="spec-row">
                          <div className="spec-item">
                            <span className="spec-label">Brand:</span>
                            <span className="spec-value">{item.brand}</span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Model:</span>
                            <span className="spec-value">{item.model}</span>
                          </div>
                        </div>

                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.city}, {item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/productdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-info-circle me-2"></i>
                            More Details
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() =>
                              removeFromWishlist(item.id, "machine")
                            }
                          >
                            <i className="bi bi-heart-fill text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

       

          {designers.length > 0 && (
            <>
              <h4 className="mt-5 mb-3">Designers</h4>

              <div className="designs-grid1">
                {designers.map((item) => {
                  return (
                    <div className="design-card" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                          className="designer-img"
                          alt={item.name}
                          style={{
                            height: "100%",
                            objectFit: "cover",
                            width: "100%",
                          }}
                        />
                      </div>

                      <div className="machine-body">
                        <h4 className="machine-name">{item.name}</h4>

                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {item.expected_salary}
                            </span>

                            <span className="text-muted">/ hr</span>
                          </div>

                          <button
                            className="contact-btn"
                            style={{
                              backgroundColor: "#00a699",
                              color: "white",
                              border: "none",
                              padding: "8px 14px",
                              borderRadius: "5px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() =>
                              navigate(`/designerdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>

                        <hr className="my-2 opacity-25" />

                        <div className="spec-row">
                          <div className="spec-item">
                            <span className="spec-label">Skill:</span>
                            <strong>{item.skills}</strong>
                          </div>

                          <div className="spec-item">
                            <span className="spec-label">Exp:</span>
                            <strong>{item.experience} Yrs</strong>
                          </div>
                        </div>

                        <div className="location-info mt-2">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.location}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/designerdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-person-badge-fill me-2"></i>
                            Hire Now
                          </button>
                          <button
                            className="footer-like-btn"
                            onClick={() =>
                              removeFromWishlist(item.id, "designer")
                            }
                          >
                            <i className="bi bi-heart-fill text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

       

          {houses.length > 0 && (
            <>
              <h4 className="mt-5 mb-3">Workspaces</h4>

              <div className="designs-grid1">
                {houses.map((item) => {
                  const images = item.image ? item.image.split(",") : [];

                  return (
                    <div className="design-card" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.WORKSPACE_IMAGE}${images[0]}`}
                          alt="workspace"
                        />
                      </div>

                      <div className="machine-body">
                        <h4 className="machine-name">{item.location}</h4>
                      
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {parseInt(item.rent_price).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <span className="rent-unit"></span>
                          </div>
                          <button
                            className="contact-btn"
                            style={{
                              backgroundColor: "#00a699",
                              color: "white",
                              border: "none",
                              padding: "8px 14px",
                              borderRadius: "5px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() =>
                              navigate(`/houserentDetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>

                        <div className="spec-row">
                          <div className="spec-item">
                            <span className="spec-label">Size:</span>
                            {item.size}
                          </div>

                          <div className="spec-item">
                            <span className="spec-label">Floor:</span>
                            {item.floor}
                          </div>
                        </div>

                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.city} , {item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/houserentDetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-info-circle me-2"></i> View
                            Details
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() => removeFromWishlist(item.id, "house")}
                          >
                            <i className="bi bi-heart-fill text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

         

          {wishlist.length === 0 && (
            <div className="empty-box text-center mt-5">
              <h5>Your wishlist is empty 😢</h5>

              <Link to="/machine" className="btn btn-primary mt-3">
                Browse Machines
              </Link>
            </div>
          )}

          {designs.length > 0 && (
            <>
              <h4 className="mt-5 mb-3">Designs</h4>

              <div className="designs-grid1">
                {designs.map((item) => {
                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => handleCardClick(item)}
                    >
                      <div className="image-wrapper">
                        <img
                          src={`${UPLOADS.DESIGN_IMAGE}${item.jpeg_file}`}
                          alt={item.design_code}
                        />
                      </div>

                      <div className="card-body">
                        <div className="design-specs">
                          <div className="spec-left">
                            <div>
                              <strong>Stitch:</strong> {item.stitch}
                            </div>
                            <div>
                              <strong>Color:</strong> {item.color}
                            </div>
                          </div>
                          <div className="spec-right text-end">
                            <div>
                              <strong>Area:</strong> {item.area}
                            </div>
                            <div>
                              <strong>Code:</strong> {item.design_code}
                            </div>
                          
                          </div>
                        </div>
                        <div className="design-specs">
                          <div>
                            <strong>Concept:</strong>{" "}
                            {item.concepts_array
                              ?.map((id) => {
                                const concept = concepts.find(
                                  (c) => c.id == id,
                                );
                                return concept ? concept.concept_name : null;
                              })
                              .filter(Boolean)
                              .join(", ")}
                          </div>
                        </div>

                        <h5 className="price-tag-row text-center mt-2">₹ 0</h5>

                        <div className="card-action-row">
                          <div className="action-btns">
                            <button
                              className={`select-btn ${cartIds.includes(item.id) ? "selected-btn" : ""}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                addToCart(item, "design");
                              }}
                            >
                              <i
                                className={`bi ${
                                  cartIds.includes(item.id)
                                    ? "bi-cart-check-fill"
                                    : "bi-cart-fill"
                                } me-1`}
                              ></i>

                              {cartIds.includes(item.id)
                                ? "SELECTED"
                                : "SELECT DESIGN"}
                            </button>

                            <button
                              className="wish-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFromWishlist(item.id, "design");
                              }}
                            >
                              <i className="bi bi-heart-fill text-danger"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )} */}
        </div>

        {/* ================= RIGHT ADS ================= */}
        <div className="col-lg-2">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>

              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
